// extracted by mini-css-extract-plugin
export default {"responseItemContainer":"FieldReflection__responseItemContainer___FA2Xd","chatbarContainer":"FieldReflection__chatbarContainer___RenZ6"};